import React, { useCallback, useEffect } from "react";
import { getCheck } from "../../../lib/calculation";
import Check from "../Check/Check";

export default function PercentCalc({
  check,
  equipment,
  topLevel,
  tosubequipmentinspection,
  station,
  data,
  set_data,
  saveTextCommentAndPhoto,
  deleteComment,
  index,
  setCheckValue,
  type,
  addInterceptor,
  params,
}) {
  const calculate = useCallback((check_copy) => {
    var a = check_copy.children[0].value;
    var b = check_copy.children[1].value;

    if (a && b) {
      var c = (100 * b) / a;

      check_copy.children[2].value = c.toFixed(1);

      check_copy.value = check_copy.children.every(function (child) {
        return child.value;
      });
    }
  }, []);

  const coarce = useCallback(
    (value, data_copy) => {
      if (!value || !data_copy) return;
      const check_result = getCheck(data_copy, check.id, topLevel);
      if (check_result) {
        calculate(check_result);
      }
    },
    [calculate, check.id, topLevel]
  );

  useEffect(() => {
    addInterceptor("PercentCalc_" + check.id, coarce);
  }, [addInterceptor, check.id, coarce]);

  return (
    <div>
      <h1>{check.title}</h1>
      <div className="text">
        <div>
          {check.critical && (
            <small className="bg-danger">
              This value puts equipment out of service!
            </small>
          )}
        </div>
        <span>
          {" "}
          <Check
            check={check.children[0]}
            equipment={equipment}
            topLevel={topLevel}
            tosubequipmentinspection={tosubequipmentinspection}
            station={station}
            data={data}
            set_data={set_data}
            saveTextCommentAndPhoto={saveTextCommentAndPhoto}
            deleteComment={deleteComment}
            index={index}
            type={type}
            setCheck={setCheckValue}
            addInterceptorValue={addInterceptor}
            params={params}
          ></Check>
        </span>{" "}
        <span>
          {" "}
          <Check
            check={check.children[1]}
            equipment={equipment}
            topLevel={topLevel}
            tosubequipmentinspection={tosubequipmentinspection}
            station={station}
            data={data}
            set_data={set_data}
            saveTextCommentAndPhoto={saveTextCommentAndPhoto}
            deleteComment={deleteComment}
            index={index}
            type={type}
            setCheck={setCheckValue}
            addInterceptorValue={addInterceptor}
            params={params}
          ></Check>
        </span>{" "}
        <span>
          {" "}
          <Check
            check={check.children[2]}
            equipment={equipment}
            topLevel={topLevel}
            tosubequipmentinspection={tosubequipmentinspection}
            station={station}
            data={data}
            set_data={set_data}
            saveTextCommentAndPhoto={saveTextCommentAndPhoto}
            deleteComment={deleteComment}
            index={index}
            type={type}
            setCheck={setCheckValue}
            addInterceptorValue={addInterceptor}
            params={params}
          ></Check>
        </span>
      </div>
    </div>
  );
}
